var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"12","viewBox":"0 0 10 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.6571 10.2857H8.51425V12H1.6571V10.2857Z","fill":"#2260FF"}}),_c('path',{attrs:{"d":"M5.94284 0H4.22856V4.28571H0.799988L5.0857 8.57143L9.37142 4.28571H5.94284V0Z","fill":"#2260FF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }